export type AnalyticsMap = { key: string; value: string }[] | null | undefined;

export function getAnalyticsFields({
  analyticsMap,
  source,
}: {
  analyticsMap: AnalyticsMap;
  source: Record<string, unknown>;
}) {
  if (!analyticsMap) {
    return null;
  }

  const result: Record<string, unknown> = {};

  for (const { key, value } of analyticsMap) {
    // support for nested fields "contact.name"
    const analyticsValue = getNestedValue(source, key);
    if (analyticsValue !== undefined) {
      result[value] = analyticsValue;
    }
  }

  return result;
}

/**
 *
 * @param obj Source object
 * @param path Target path separated by "."
 * @returns Value of target field or undefined
 */
function getNestedValue(obj: Record<string, unknown>, path: string) {
  let value: Record<string, unknown> | unknown = obj;

  for (const field of path.split('.')) {
    value =
      value && typeof value === 'object' && field in value ? (value as any)[field] : undefined;
  }

  return value;
}
